import { render, staticRenderFns } from "./Talentos.vue?vue&type=template&id=07434af4&scoped=true&"
import script from "./Talentos.vue?vue&type=script&lang=js&"
export * from "./Talentos.vue?vue&type=script&lang=js&"
import style0 from "./Talentos.vue?vue&type=style&index=0&id=07434af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07434af4",
  null
  
)

export default component.exports